import { motion } from 'framer-motion';

export const EntryRequirementsSection = ({
  requirements,
  sectionLabel = 'Eligibility',
  title = 'Entry Requirements',
  description = 'Applicants are generally expected to demonstrate the following qualifications. Applications are reviewed by the Admissions Team as part of the admission and scholarship review process.',
}) => (
  <section className="py-20 md:py-32 bg-[#163A59]">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-white"
        >
          <p className="text-sm font-medium uppercase tracking-widest opacity-80 mb-4">
            {sectionLabel}
          </p>
          <h2 className="font-['Source_Serif_4'] text-3xl md:text-4xl font-bold mb-6">
            {title}
          </h2>
          <p className="text-lg opacity-90 leading-relaxed">
            {description}
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
          className="bg-white/10 backdrop-blur-sm p-8 rounded-sm"
        >
          <div className="space-y-4">
            {requirements.map((req, index) => (
              <div key={req} className="flex items-start gap-4">
                <div className="w-8 h-8 bg-[#C82032] text-white flex items-center justify-center rounded-sm font-semibold text-sm flex-shrink-0">
                  {index + 1}
                </div>
                <span className="text-white/90 pt-1">{req}</span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);
